import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useForm } from 'react-hook-form';
import DateTimeField from '@1stquad/react-bootstrap-datetimepicker';
import '@1stquad/react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.css'
import moment from 'moment';
import ImageUpload from "./Custom-Post-Upload";
import AuthorUpload from "./Author-Profile-Upload";
import { SWAL_FIRE, TOAST_ERROR, TOAST_SUCCESS, TOAST_LOADING, TOAST_DISMISS, validURL } from "../../../../../utils";
import Select from 'react-select';
import { getNetworklist, getPost, customPostsubmit, getFeedlist, deleteCustomPost, statusUpdateCustomPost, geteditPost, customPostUrlsubmit } from '../../../../../actions/appsMoreAction';
import { refreshThemes } from '../../../../../actions/firstRunAction';
import { closePricingModal } from '../../../../../utils/close_modal';
import { shallowEqual, useDispatch } from 'react-redux';
import { MediaBaseUrl } from '../../../../../actions/api';
import { baseUrl } from '../../../../../utils';
import { useSelector } from 'react-redux';
import { ASSETS_URL, UPPY_BUCKET_URL } from '../../../../../actions/constant';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const recurrenceAfter = [
    { label: "10", value: '10' },
    { label: "20", value: '20' },
    { label: "30", value: '30' },
];

const recurrence = [
    { label: "Never", value: '0' },
    { label: "A little", value: '10' },
    { label: "A lot", value: '5' },
];

const CustomPost = ({ showcustomPost, closecustomPost, getData }) => {
    const dispatch = useDispatch();

    const [wallId, setWallId] = useState(getData.detail?.wallId || '');
    const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
    const { register: postUrl, handleSubmit: handleSubmitPosturl, clearPosturlErrors, formState: { errors: errorspostUrl } } = useForm();

    const [ImageUploadStatus, setImageUploadStatus] = useState(1);
    const [emptyData, setemptyData] = useState(0);
    const [videoType, setvideoType] = useState(0);
    const [postType, setpostType] = useState(0);
    const [createPostForm, setcreatePostForm] = useState(0);
    const [createPost, setcreatePost] = useState(0);
    const [editPost, seteditPost] = useState(0);
    const [customForm, setcustomForm] = useState(0);
    const [Feedstatus, setFeedstatus] = useState(0);
    const [postImage, setpostImage] = useState('');
    const [authorImage, setauthorImage] = useState('');
    const [getNetworkdata, setgetNetworkdata] = useState([]);
    const [feed, setFeed] = useState([]);
    const [feedUrl, setFeedUrl] = useState([]);
    const [getPostdata, setgetPostdata] = useState();
    const [mediaHeight, setmediaHeight] = useState(0);
    const [mediaWidth, setmediaWidth] = useState(0);
    const [mediaFilePath, setmediaFilePath] = useState("");
    const [feedId, setfeedId] = useState('');
    const [networkName, setnetworkName] = useState();
    const [networkId, setnetworkId] = useState(0);
    const [recureEveryOption, setrecureEveryOption] = useState(0);
    const [recureAfter, setrecureAfter] = useState(10);
    const [postRecurence, setpostRecurence] = useState('');
    const [spinner, setspinner] = useState(false);
    const [spinnerPostUrl, setspinnerPostUrl] = useState(false);
    const [urlNetwork, seturlNetwork] = useState();

    // POST URL STATES
    const [getNetworkdataPurl, setgetNetworkdataPurl] = useState([]);
    const [feedIdPurl, setfeedIdPurl] = useState('');
    const [networkIdPurl, setnetworkIdPurl] = useState(0);
    const [recureEveryOptionPurl, setrecureEveryOptionPurl] = useState(0);
    const [recureAfterPurl, setrecureAfterPurl] = useState(0);
    const [postRecurencePurl, setpostRecurencePurl] = useState(0);
    const [urlError, seturlError] = useState(null);
    // POST URL STATES

    const [expandedPosts, setExpandedPosts] = useState({});
    const [mediaType, setmediaType] = useState(null);
    const [thumbFile, sethumbFile] = useState('');
    const [mediaSize, setmediaSize] = useState([]);
    const [postCreatedAt, setPostCreatedAt] = useState(null);

    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const userPlan = userData?.UserPlan || {};

    const myRefname = useRef(null);
    const myEditRefname = useRef(null);

    const onPostUpload = (url) => {
        if (mediaType == 'image') setpostImage(`${UPPY_BUCKET_URL}media/tmpimages/${url}`);
    }

    const onAuthourUpload = (url) => {
        setauthorImage(`${UPPY_BUCKET_URL}media/tmpimages/${url}`);
    }

    const handleChange = newDate => {
        setTimeout(() => myRefname.current.state.showPicker = true, 1000);
    };

    const handleEditChange = newDate => {
        setPostCreatedAt(newDate);
        setTimeout(() => myEditRefname.current.state.showPicker = true, 1000);
    };


    const deletePost = (id, index) => {
        SWAL_FIRE({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#FF4051",
            cancelButtonColor: "#E4E6EF",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.value) {
                deleteCustomPost(wallId, id).then((response) => {
                    TOAST_LOADING();
                    if (response.data.responseCode == 200) {
                        TOAST_DISMISS();
                        if (response.data.responseStatus == 'success') {
                            TOAST_SUCCESS("Post deleted successfully.");
                            var array = getPostdata.customPosts;
                            if (index !== -1) {
                                array.splice(index, 1);
                                setgetPostdata({ 'customPosts': array, ...getPostdata });
                                if (!array.length) setemptyData(1);
                            }
                        } else {
                            TOAST_ERROR('Error');
                        }
                    }
                }).catch((error) => {
                    TOAST_DISMISS();
                    TOAST_ERROR(error.message);
                })
            } else if (result.dismiss === "cancel") {
            }
        });
    }

    const statusUpdatePost = (id, value, Index) => {
        TOAST_LOADING();
        statusUpdateCustomPost(wallId, id, value).then((response) => {
            TOAST_DISMISS();
            if (response.data.responseCode == 200) {
                if (response.data.responseStatus == 'success') {
                    TOAST_SUCCESS("Status updated successfully");
                    dispatch(refreshThemes());
                    closePricingModal(dispatch);
                } else TOAST_ERROR('Error');
            }
        }).catch((error) => {
            TOAST_DISMISS();
            TOAST_ERROR(error.message);
        })
    }


    const getpostDetail = (id) => {
        seteditPost(1)
        geteditPost(localStorage.getItem('ownerId'), id).then((response) => {

            if (response.data.responseCode == 200) {
                if (response.data.responseStatus == "success") {

                    const dt = response.data.responseData[0];
                    if (networkId) setfeedId(dt.feedId);

                    setValue("content", dt.content);
                    setValue("authorName", dt.username);
                    setValue("link", dt.link);
                    setValue("eid", dt.postEditId);
                    setnetworkId(dt.networkId);
                    setnetworkName(dt.name);
                    setrecureEveryOption(dt.postRecurence);
                    setpostRecurence(!dt.every ? 0 : dt.every);
                    setrecureAfter(!dt.after ? 10 : dt.after);
                    setpostType(dt.type);
                    setmediaHeight(dt.mediaHeight);
                    setmediaWidth(dt.mediaWidth);
                    setpostImage(dt.type == 4 || dt.type == 2 ? dt.postFile : dt.mediaFile);
                    setauthorImage(dt.picture);
                    setmediaType(dt.type == 1 ? 'content' : (dt.type == 4 || dt.type == 2 ? 'image' : 'video'));
                    sethumbFile(dt.type == 5 || dt.type == 3 ? dt.postFile : '')
                    setImageUploadStatus(dt.networkId == 19 || dt.networkId == 4 || dt.networkId == 23 ? 0 : 1);
                    setPostCreatedAt(new Date(dt.postCreatedAt * 1000));
                }
            }
        }).catch((error) => TOAST_DISMISS())
    }


    const onPosturlSubmit = (value) => {
        const formData = new FormData();
        if (validURL(value.post_url)) {
            if (value.post_url.trim().length == 0) {
                TOAST_ERROR('Input invalid');
                return false
            }

            if (networkIdPurl == 0) {
                TOAST_ERROR(`Please select a network.`);
                return false;
            }

            if (networkIdPurl) {
                let network = urlNetwork.toLowerCase();
                if (network == 'instagram business') network = 'instagram';
                const fallbackDomains = {
                    twitter: 'x.com',
                    instagram: 'instagram.',
                    tiktok: 'tiktok.',
                    linkedin: 'linkedin.',
                    facebook: 'facebook.',
                    youtube: 'youtube.',
                    bluesky: 'bsky.app',
                };

                let linkUrl = value.post_url.includes(network);
                if (!linkUrl && fallbackDomains[network]) linkUrl = value.post_url.includes(fallbackDomains[network]);

                if (!linkUrl) {
                    TOAST_ERROR(`Please add ${urlNetwork} network post URL`);
                    return false;
                }
            }

            setspinnerPostUrl(true);
            TOAST_LOADING();

            formData.append('networkId', networkIdPurl);
            formData.append('postUrl', value.post_url);
            formData.append('feedId', feedIdPurl);
            formData.append('recureEvery', postRecurencePurl ? postRecurencePurl : 0);
            formData.append('recureAfter', recureAfterPurl ? recureAfterPurl : (recureEveryOptionPurl ? 10 : 0));
            formData.append('postRecurence', recureEveryOptionPurl ? 1 : 0);

            customPostUrlsubmit(wallId, Object.fromEntries(formData)).then((response) => {
                TOAST_DISMISS();
                if (response.data.responseCode == 200) {
                    if (response.data.responseStatus == 'success') {
                        TOAST_SUCCESS("Post created successfully.");
                        closecustomPost();
                        dispatch(refreshThemes());
                        closePricingModal(dispatch);
                    } else {
                        TOAST_ERROR('Error');
                    }
                }
                setspinnerPostUrl(false);
            }).catch((error) => {
                setspinnerPostUrl(false);
                TOAST_DISMISS();
                TOAST_ERROR(error?.response?.data?.responseCode == 409 ? error?.response?.data?.responseMessage : error?.message || "Something went wrong");
            })
        } else {
            TOAST_ERROR(`Post Url doesn't valid `);
        }
    }


    const getPostfeed = (e, status) => {
        if (e == 0) {
            let feedList = [{ label: 'No Feed', value: "" }];
            if (status == 1) {
                setfeedId(0);
                setFeed(feedList);
            } else {
                setFeedstatus(Math.random());
                setFeedUrl(feedList);
                setfeedIdPurl(0);
            }
        } else {
            getFeedlist(wallId, e).then((response) => {
                if (response && response.data.responseCode == 200) {
                    let feedList = [];
                    if (response.data.responseData && response.data.responseData.length > 0) {
                        feedList = response.data.responseData.map((item, i) => { return ({ label: item.name, value: item.id }) });
                    }
                    feedList = [{ label: 'No Feed', value: "" }, ...feedList];
                    if (status == 1) {
                        setfeedId(0);
                        setFeed(feedList);
                    } else {
                        setFeedstatus(Math.random());
                        setFeedUrl(feedList);
                        setfeedIdPurl(0);
                    }
                }
            }).catch(ex => console.log(ex, "ex"));
        }
    }


    const onCustomPostSubmit = (values) => {

        const formData = new FormData();

        if (values.eid) {
            formData.append('eid', values.eid);
            formData.append('action', "update");
            formData.append('createdAt', `${myEditRefname.current.state.inputValue}:00`);
        } else {
            formData.append('createdAt', myRefname.current.state.inputValue);
            formData.append('link', values.link);
            formData.append('feedId', feedId);
        }

        if (values.authorName.trim().length == 0 || values.content.trim().length == 0) {
            TOAST_ERROR('Input invalid');
            return false
        }


        if (values.link != 'undefined' && values.link.trim().length != 0) {
            var valid = /^(ftp|http|https):\/\/[^ "]+$/.test(values.link);
            if (!valid) {
                seturlError("Please Fill Valid Url (http://link)")
                return false
            }
        }


        let type = 1;
        setspinner(true);

        if (mediaType == 'content') {
            type = 1;
        } else if (mediaType == 'image' && values.content) {
            type = 4;
        } else if (mediaType == 'image' && !values.content) {
            type = 2;
        } else if (mediaType == 'video' && !values.content) {
            type = 3;
        } else if (mediaType == 'video' && values.content) {
            type = 5;
        }

        if (networkId != 19 && networkId != 4 && networkId != 23) {
            formData.append('postFile', mediaType == 'video' ? thumbFile : postImage);
            formData.append('mediaFile', mediaType == 'video' ? postImage : "");
            formData.append('mediaFilePath', mediaFilePath);
        } else {
            type = 1;
        }

        formData.append('authorFile', authorImage);
        formData.append('authorName', values.authorName);
        formData.append('content', values.content);
        formData.append('networkName', networkName ? networkName : 'No Network');
        formData.append('networkId', networkId ? networkId : 0);
        formData.append('recureEveryOption', recureEveryOption ? 1 : 0);

        formData.append('recureEvery', recureEveryOption ? (postRecurence ? postRecurence : 0) : 0);
        formData.append('recureAfter', recureEveryOption ? (recureAfter ? recureAfter : (recureEveryOption ? 10 : 0)) : 0);
        formData.append('ownerId', localStorage.getItem('ownerId'));
        formData.append('referenceId', parseInt(Date.now() / 100000));
        formData.append('mediaHeight', mediaSize.height ? mediaSize.height : mediaHeight);
        formData.append('mediaWidth', mediaSize.width ? mediaSize.width : mediaWidth);
        formData.append('type', type);
        formData.append('postId', 0);
        formData.append('rating', 0);
        formData.append('isAdmin', 0);
        formData.append('adminId', 0);
        formData.append('videoType', videoType);

        customPostsubmit(localStorage.getItem('ownerId'), wallId, Object.fromEntries(formData)).then((response) => {

            TOAST_DISMISS();

            if (response.data.responseCode == 200) {
                if (response.data.responseStatus == 'success') {
                    TOAST_SUCCESS(`Post ${values.eid ? 'update' : 'created'}  successfully.`);
                    closecustomPost();
                    dispatch(refreshThemes());
                    closePricingModal(dispatch);
                } else {
                    TOAST_ERROR('Error');
                }
            } else if (response.data.responseCode == 404) {
                TOAST_ERROR(response.data.responseMessage);
            } else if (response.data.responseCode == 409) {
                TOAST_ERROR("Post is Already Exist");
            }

            setspinner(false);
        }).catch((error) => {
            TOAST_DISMISS();
            setspinner(false);
            TOAST_ERROR(error?.response?.data?.responseCode == 409 ? error?.response?.data?.responseMessage : error?.message || "Something went wrong");
        })
    }


    const uploadfileNetwork = (value) => {
        setImageUploadStatus(value == 19 || value == 4 || value == 23 ? 0 : 1);
    }

    useEffect(() => {
        getNetworklist(wallId, userPlan?.planId, '0').then((response) => {
            if (response.data.responseCode == 200) {
                const postUrlNetworks = [{ label: 'No Network', value: 0 }];
                const networkData = [{ label: 'No Network', value: 0 }, ...(response?.data?.responseData?.filter((item) => item.id != 26)?.map((item) => {
                    const obj = { label: item?.name ?? "", value: item?.id ?? "" };
                    const baseIds = [1, 6, 8, 18, 28, ...(userPlan?.planId !== 58 ? [...(userPlan?.planId != 1 ? [3] : []), 31, 7] : [])];
                    if (baseIds.includes(item.id)) postUrlNetworks.push(obj);
                    return obj;
                }) || [])];

                setgetNetworkdata(networkData);
                setgetNetworkdataPurl(postUrlNetworks);
            }
        }).catch(ex => console.log(ex, "ex"));


        getPost(localStorage.getItem('ownerId'), wallId).then((response) => {

            TOAST_LOADING();

            if (response.data.responseCode == 200) {
                setgetPostdata(response.data.responseData);
            }

            TOAST_DISMISS();
            setcreatePostForm(1);
            setcustomForm(1);
        }).catch(ex => console.log(ex, "ex"));

        if (showcustomPost == false) {
            setcreatePost(0);
            seteditPost(0);
            setrecureEveryOption(false);
            clearErrors('authourName');
            clearErrors('content');
            clearPosturlErrors('post_url');
        }

    }, [showcustomPost]);


    const createForm = () => {
        setemptyData(0);
        setfeedId(0);
        setValue("content", "");
        setValue("authorName", "");
        setValue("link", "");
        setValue("eid", "");
        setnetworkId("");
        setmediaHeight(0);
        setmediaWidth(0);
        setnetworkName("");
        setrecureEveryOption("");
        setpostRecurence("");
        setrecureAfter("");
        setpostImage("");
        setauthorImage("");
        setImageUploadStatus(1);
        setmediaFilePath("");
    }


    return (
        <>

            {customForm ?

                <Modal size="lg" show={showcustomPost} onHide={closecustomPost} centered>
                    <Modal.Header className="personalize_wt" closeButton>
                        <Modal.Title className="modal-title">Custom Post</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-0 add_pro_wrap">
                        <>
                            {
                                emptyData ?

                                    <>
                                        <div className="text-center commanEmW" style={{ margin: '2rem' }}>
                                            <img src={baseUrl('error/drop-box.svg')} className="commanImgModal"
                                                style={{ width: '150px' }} />
                                            <p className="commanPeraModal" style={{ color: "#6E7073" }}>Oops! Nothing found</p>
                                            <div className="buttonUpgred">
                                                <a href="#" onClick={(e) => { setcreatePost(1); createForm() }} data-bs-toggle="tab" aria-expanded="false" className="btn btn-primary btn4CommanEmW" data-factors-click-bind="true">
                                                    Add Custom Post
                                                </a>
                                            </div>
                                        </div>
                                    </>

                                    :

                                    <>
                                        {createPostForm ?

                                            createPost == 0 && getPostdata && getPostdata.customPosts.length > 0 ?

                                                editPost == 0 ?

                                                    // LIST CUSTOM POST/URL CODE START 

                                                    <div className="row customPostSec postcWrapC">
                                                        <div className="col-md-12 wallcreateshow">
                                                            <div className="modal-body">
                                                                <div className="tab-content">
                                                                    <div className="tab-pane fade active show">
                                                                        <div className="table-scrollable table-scrollable-borderless globalTblList custom_posts_table table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                                            <table className="table table-hover">
                                                                                <thead>
                                                                                    <tr className="uppercase text-center" align="center">
                                                                                        <th align="left" style={{ textAlign: 'left' }}>
                                                                                            Author</th>
                                                                                        <th>
                                                                                            Network</th>
                                                                                        <th>
                                                                                            Content</th>
                                                                                        <th>
                                                                                            Status </th>
                                                                                        <th className="text-right">
                                                                                            Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>

                                                                                    {getPostdata && getPostdata.customPosts.map((item, Index) => {

                                                                                        return (<tr className="text-center" align="center">
                                                                                            <td className="authorPicTd text-left" width="20%" key={Index}>

                                                                                                <img src={item?.picture || `${MediaBaseUrl}users/author.png`} className="me-3" style={{ borderRadius: '50%', height: '32px', width: '32px' }} alt="author" onError={(e) => { e.target.src = `${MediaBaseUrl}users/author.png` }} /> {item.username}</td>

                                                                                            <td width="10%">
                                                                                                {item.icon ? <i className={`fab ${item.icon}`}></i> : `N/A`}
                                                                                            </td>

                                                                                            <td width="50%">
                                                                                                <div className="d-flex align-items-center justify-content-center">
                                                                                                    {/* {item.type} */}

                                                                                                    {item.postFile && item.postFile != 'undefined' ?

                                                                                                        <span className="preview-thumnail position-relative me-4" style={{ display: 'inline-block' }}>
                                                                                                            <Image src={item.postFile} width="80" height="60" style={{ objectFit: 'cover', borderRadius: '4px', display: 'block' }} />
                                                                                                            {item.type == 3 || item.type == 5 ?
                                                                                                                <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'rgba(0,0,0,0.5)', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                                    <FontAwesomeIcon type={'solid'} icon={'video'} iconClass={'fs-6 text-white'} />
                                                                                                                </span>
                                                                                                                : null}
                                                                                                        </span>
                                                                                                        : null}

                                                                                                    <div className="custom_post_content">
                                                                                                        <p style={{ wordBreak: 'break-all', marginBottom: '2px' }}>
                                                                                                            {expandedPosts[item.id] || item.content.length <= 100
                                                                                                                ? item.content
                                                                                                                : item.content.slice(0, 100) + '...'}
                                                                                                        </p>
                                                                                                        {item.content.length > 100 && (
                                                                                                            <span
                                                                                                                onClick={(e) => { e.stopPropagation(); setExpandedPosts(prev => ({ ...prev, [item.id]: !prev[item.id] })); }}
                                                                                                                style={{ color: '#3699FF', cursor: 'pointer', fontSize: '12px', whiteSpace: 'nowrap' }}
                                                                                                            >
                                                                                                                {expandedPosts[item.id] ? 'Read Less' : 'Read More'}
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td className="text-center" width="10%">
                                                                                                <div className="toggleOnBut">
                                                                                                    <span className="switch justify-content-center">
                                                                                                        <label className='d-flex' htmlFor={`data${item.id}`}>
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                name={`data`}
                                                                                                                id={`data${item.id}`}
                                                                                                                className="onoffswitch-checkbox updateStatus"
                                                                                                                defaultChecked={item.status}
                                                                                                                onChange={(e) => statusUpdatePost(item.id, e.target.checked, Index)}
                                                                                                            />
                                                                                                            <span></span>
                                                                                                        </label>
                                                                                                    </span>
                                                                                                </div>
                                                                                            </td>

                                                                                            <td className="actionsEditR text-nowrap" width="20%">
                                                                                                <div onClick={(e) => getpostDetail(item.id)} title="Edit" className="btn btn-icon btn-sm btn-clean popUp maintainPopUp" data-dismiss="modal" data-popup-width="data-width='750px'">
                                                                                                    <FontAwesomeIcon type={'solid'} icon={'pencil'} iconClass={'fs-6 text-dark'} />
                                                                                                </div>
                                                                                                <div onClick={(e) => deletePost(item.id, Index)} className="btn btn-icon btn-sm btn-clean delete">
                                                                                                    <FontAwesomeIcon type={'solid'} icon={'trash-can'} iconClass={'fs-6 text-dark'} />
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                        )
                                                                                    })}

                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <Button variant='primary' size='sm' onClick={(e) => { setcreatePost(1); createForm() }}>Create New</Button>
                                                                <OverlayTrigger placement="right" overlay={<Tooltip>Help</Tooltip>}>
                                                                    <a href="https://vimeo.com/545389025/2212c02051" className="ms-2 d-flex pt-1 lity_lightbox" data-lity>
                                                                        <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5 text-secondary'} />
                                                                    </a>
                                                                </OverlayTrigger>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    // LIST CUSTOM POST/URL CODE END

                                                    :

                                                    // EDIT CUSTOM POST/URL CODE START

                                                    <form onSubmit={handleSubmit(onCustomPostSubmit)} noValidate className="maintainPopUp" encType="multipart/form-data" method="post" acceptCharset="utf-8">
                                                        <div className='modal-body'>
                                                            <div className="row">

                                                                <div className="col-md-6">

                                                                    {ImageUploadStatus ?
                                                                        <>
                                                                            <input type="hidden" {...register("postFile")} className="form-control" defaultValue={postImage} />
                                                                            <ImageUpload setmediaFilePath={setmediaFilePath} setvideoType={setvideoType} setpostImage={setpostImage} setmediaSize={setmediaSize} setmediaWidth={setmediaWidth} setmediaHeight={setmediaHeight} sethumbFile={sethumbFile} postType={postType} onImgUpload={onPostUpload} mediaTypeFile={mediaType} setmediaType={setmediaType} onRemovePost={setpostImage} imageName={postImage} /></> : null}

                                                                </div>

                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <div className="d-flex align-items-end">

                                                                            <input type="hidden" {...register("eid", { required: true, required: 'This field is required.' })} />

                                                                            <div className="symbol symbol-40 symbol-sm flex-shrink-0 me-3">

                                                                                <input type="hidden" {...register("authorFile")} className="form-control" defaultValue={authorImage} />
                                                                                <AuthorUpload authorImage={authorImage} onRemoveAuthor={setauthorImage} onImgUpload={onAuthourUpload} imageName={authorImage} />
                                                                            </div>

                                                                            <div className="d-flex flex-column w-100"><label htmlFor="authorName">Author Name</label><input  {...register("authorName", { required: true, required: 'This field is required.' })} className="form-control" type="text" />
                                                                            </div>
                                                                        </div>
                                                                        {errors.authorName && <span className="text-error">{errors.authorName.message}</span>}
                                                                    </div>

                                                                    <div className="form-group after">
                                                                        <label htmlFor="PostContent">Content</label><textarea {...register("content", { required: true, required: 'This field is required.' })} className="form-control" rows="6" cols="5"></textarea>
                                                                        {errors.content && <span className="text-error">{errors.content.message}</span>}
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label htmlFor="postcAt">
                                                                            Created At
                                                                        </label>

                                                                        <div className="input-group date dateTimePicker fgroupEndAtHide" data-target-input="nearest">
                                                                            {postCreatedAt ? <DateTimeField
                                                                                language={'en'}
                                                                                open={true}
                                                                                // minDate={minimalDate}
                                                                                maxDate={new Date()}
                                                                                dateTime={moment(postCreatedAt).format('MM/DD/YYYY, hh:mm:ss a')}
                                                                                inputFormat={'YYYY-MM-DD HH:mm'}
                                                                                onChange={(e) => handleEditChange(e)}
                                                                                viewMode={'date'}
                                                                                closeOnClickOutside={false}
                                                                                closeOnTab={false}
                                                                                className="form-control"
                                                                                startOfWeek={'week'}
                                                                                ref={myEditRefname}
                                                                                direction="top"
                                                                                widgetStyle={{ left: '0' }}
                                                                                key={'editCreatedAt'}
                                                                            /> : <input className="form-control" type="text" />}




                                                                            <div onClick={(e) => { myEditRefname.current.onClick() }} className="input-group-append" data-target="#postcAt" data-toggle="datetimepicker">
                                                                                <span className="input-group-text">
                                                                                    <FontAwesomeIcon type={'regular'} icon={'calendar-days'} iconClass={'fs-6 text-dark'} />
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    <div className="form-group">
                                                                        <label htmlFor="networkId">Network</label>
                                                                        {/* { menuPlacement="top" } */}
                                                                        <Select menuPlacement="auto"
                                                                            //    styles={{   option: (styles, { data }) => ({ ...styles, display: data.value < 0 ? 'none' : 'block' }) }}

                                                                            onChange={(e) => { setnetworkId(e.value); setnetworkName(e.label); uploadfileNetwork(e.value); }} options={getNetworkdata} value={getNetworkdata[getNetworkdata.findIndex(i => i.value == networkId)]} clearable={false} />
                                                                    </div>


                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <span>Recurring Options </span>
                                                                                <span className="switch switch-xs">
                                                                                    <label className="col-form-label">
                                                                                        <input onClick={(e) => setrecureEveryOption(!recureEveryOption)} checked={recureEveryOption} className="toggle_switcher" type="checkbox" />
                                                                                        <span></span>
                                                                                    </label>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                {recureEveryOption ?
                                                                    <div>
                                                                        <div className="separator separator-dashed my-5"></div>
                                                                        <div className="row forRecure">
                                                                            <div className="col-sm-6">
                                                                                <div className="form-group after">
                                                                                    <div>
                                                                                        <label className="recur">
                                                                                            Recurrence
                                                                                        </label>
                                                                                        <div>
                                                                                            <Select menuPlacement="auto" onChange={(e) => setpostRecurence(e.value)} options={recurrence} value={recurrence[recurrence.findIndex(i => i.value == postRecurence)]} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-sm-6">
                                                                                <div className="form-group after">
                                                                                    <label className="recur">
                                                                                        Start Recurrence After
                                                                                    </label>
                                                                                    <div>
                                                                                        <Select menuPlacement="auto" onChange={(e) => setrecureAfter(e.value)} options={recurrenceAfter} value={recurrenceAfter[recurrenceAfter.findIndex(i => i.value == recureAfter)]} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    : null}

                                                            </div>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <div className="d-flex align-items-center justify-content-end w-100">
                                                                <div className="card-toolbar">
                                                                    <button onClick={(e) => { setcreatePost(0); seteditPost(0); setpostImage(""); setPostCreatedAt(null) }} type="button" className="btn btn-secondary me-4" data-bs-dismiss="modal">Cancel</button>
                                                                    <button type="submit" className={`btn btn-primary addMoreAnnocBtn ladda-button  ${spinner ? `spinner spinner-white spinner-right disabled` : null}`}> Update Custom Post</button>

                                                                    <OverlayTrigger overlay={<Tooltip>Help</Tooltip>}>
                                                                        <Link
                                                                            href="https://taggbox.com/support/how-to-create-add-custom-posts/"
                                                                            target="_blank"
                                                                            className="commanColor absoluteRight ms-2"
                                                                            data-theme="dark"
                                                                            style={{ right: '15px' }}
                                                                        >

                                                                            <span className="svg-icon svg-icon-muted svg-icon-lg" data-placement="right" data-theme="dark">
                                                                                <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5 text-secondary'} />
                                                                            </span>
                                                                        </Link>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>

                                                // EDIT CUSTOM POST/URL CODE END


                                                // ADD CUSTOM POST/URL CODE START
                                                :
                                                <div className="tab-pane fade active show my-modal" style={{ paddingTop: '0px !important' }}>
                                                    <Tabs
                                                        defaultActiveKey={'custom-post'}
                                                        className="px-3 nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-tabs-bold w-100 active"
                                                    >

                                                        {/* CUSTOM POST START */}

                                                        <Tab eventKey="custom-post" title={<span>Custom Post</span>}>
                                                            <form onSubmit={handleSubmit(onCustomPostSubmit)} noValidate className="maintainPopUp" encType="multipart/form-data" method="post" acceptCharset="utf-8">
                                                                <div className='modal-body'>
                                                                    <div className="row">

                                                                        <div className="col-md-6">

                                                                            {ImageUploadStatus ?
                                                                                <>
                                                                                    <input type="hidden" {...register("postFile")} className="form-control" defaultValue={postImage} />
                                                                                    <ImageUpload setmediaFilePath={setmediaFilePath} setvideoType={setvideoType} setpostImage={setpostImage} setmediaSize={setmediaSize} sethumbFile={sethumbFile} setmediaWidth={setmediaWidth} setmediaHeight={setmediaHeight} postType={postType} onImgUpload={onPostUpload} setmediaType={setmediaType} mediaTypeFile={mediaType} onRemovePost={setpostImage} imageName={postImage} /></> : null}
                                                                        </div>

                                                                        <div className="col-md-6">
                                                                            <div className="form-group">
                                                                                <div className="d-flex align-items-end">

                                                                                    <div className="symbol symbol-40 symbol-sm flex-shrink-0 me-3">
                                                                                        <input type="hidden" {...register("authorFile")} className="form-control" defaultValue={authorImage} />
                                                                                        <AuthorUpload authorImage={authorImage} onRemoveAuthor={setauthorImage} onImgUpload={onAuthourUpload} imageName={authorImage} />
                                                                                    </div>

                                                                                    <div className="d-flex flex-column w-100"><label htmlFor="authorName">Author Name </label><input  {...register("authorName", { required: true, required: 'This field is required.' })} className="form-control" type="text" />
                                                                                    </div>
                                                                                </div>
                                                                                {errors.authorName && <span className="text-error">{errors.authorName.message}</span>}

                                                                            </div>

                                                                            <div className="form-group after">
                                                                                <label htmlFor="PostContent">Content</label><textarea {...register("content", { required: true, required: 'This field is required.' })} className="form-control" rows="6" cols="5"></textarea>
                                                                                {errors.content && <span className="text-error">{errors.content.message}</span>}
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <label htmlFor="postcAt">
                                                                                    Created At    </label>

                                                                                <div className="input-group" data-target-input="nearest">
                                                                                    <DateTimeField
                                                                                        language={'en'}
                                                                                        open={true}
                                                                                        // minDate={minimalDate}
                                                                                        maxDate={new Date()}
                                                                                        dateTime={moment(new Date()).format('MM/DD/YYYY, hh:mm:ss a')}
                                                                                        inputFormat={'YYYY-MM-DD HH:mm'}
                                                                                        onChange={(e) => handleChange(e)}
                                                                                        viewMode={'date'}
                                                                                        closeOnClickOutside={false}
                                                                                        closeOnTab={false}
                                                                                        className="form-control"
                                                                                        startOfWeek={'week'}
                                                                                        ref={myRefname}
                                                                                        direction="top"
                                                                                        widgetStyle={{ left: '0', width: '80%' }}
                                                                                    />




                                                                                    <div onClick={(e) => { myRefname.current.onClick() }} className="input-group-append" data-target="#postcAt" data-toggle="datetimepicker">
                                                                                        <span className="input-group-text">
                                                                                            <FontAwesomeIcon type={'regular'} icon={'calendar-days'} iconClass={'fs-6 text-dark'} />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <div className="input text"><label htmlFor="linkpost">Link</label><input  {...register("link")} onChange={(e) => !e.target.value ? seturlError(null) : ''} className="form-control" maxLength="255" type="text" />
                                                                                    {urlError && <span className="text-error">{urlError}</span>}
                                                                                </div>
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <label htmlFor="networkId">Network  </label>
                                                                                <Select menuPlacement="auto"
                                                                                    onChange={(e) => { uploadfileNetwork(e.value); setnetworkId(e.value); setnetworkName(e.label); getPostfeed(e.value, 1); }} options={getNetworkdata} defaultValue={getNetworkdata[0]} />
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <label htmlFor="CustomPostFeedId">Feed </label>
                                                                                <Select menuPlacement="auto"
                                                                                    onChange={(e) => setfeedId(e.value)} name="CustomPostFeedId" defaultValue={feed[0]} value={feed[feed.findIndex(i => i.value == feedId)]} options={feed} />
                                                                            </div>

                                                                            <div className="row">
                                                                                <div className="col-6">
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <span> Recurring Options </span>
                                                                                        <span className="switch switch-xs">
                                                                                            <label className="col-form-label">
                                                                                                <input onClick={(e) => setrecureEveryOption(recureEveryOption == true ? false : true)} defaultChecked={recureEveryOption} className="toggle_switcher" type="checkbox" />
                                                                                                <span></span>
                                                                                            </label>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {recureEveryOption == true ?
                                                                            <div>
                                                                                <div className="separator separator-dashed my-5"></div>
                                                                                <div className="row forRecure">
                                                                                    <div className="col-sm-6">
                                                                                        <div className="form-group after">
                                                                                            <div>
                                                                                                <label className="recur">
                                                                                                    Recurrence
                                                                                                </label>
                                                                                                <div>
                                                                                                    <Select menuPlacement="auto" onChange={(e) => setpostRecurence(e.value)} options={recurrence} defaultValue={recurrence[0]} />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-sm-6">
                                                                                        <div className="form-group after">
                                                                                            <label className="recur">
                                                                                                Start Recurrence After
                                                                                            </label>
                                                                                            <div>
                                                                                                <Select menuPlacement="auto" onChange={(e) => setrecureAfter(e.value)} options={recurrenceAfter} defaultValue={recurrenceAfter[0]} />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            : null}

                                                                    </div>
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <div className="d-flex align-items-center justify-content-end w-100">
                                                                        <div className="card-toolbar">
                                                                            <Button variant='secondary' onClick={(e) => closecustomPost()} type="button" className="me-2" data-bs-dismiss="modal">Cancel</Button>
                                                                            <Button variant='primary' type="submit" className={`addMoreAnnocBtn ladda-button  ${spinner ? `spinner spinner-white spinner-right disabled` : null}`}>Create Custom Post</Button>

                                                                            <OverlayTrigger overlay={<Tooltip>Help</Tooltip>}>
                                                                                <a href="https://taggbox.com/support/how-to-create-add-custom-posts/" target="_blank" className='ms-2'>
                                                                                    <span className="svg-icon svg-icon-muted svg-icon-lg">
                                                                                        <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5 text-secondary'} />
                                                                                    </span>
                                                                                </a>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </Tab>
                                                        {/* POST URL START */}

                                                        {getNetworkdataPurl.length > 1 && <Tab eventKey="profile" title="Post Url">
                                                            <form noValidate onSubmit={handleSubmitPosturl(onPosturlSubmit)} className="maintainPopUp" encType="multipart/form-data" method="post" acceptCharset="utf-8">
                                                                <div className='modal-body'>
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <input type="hidden" className="form-control" value="" /> <label htmlFor="networkId">Network</label>
                                                                                <Select menuPlacement="auto" onChange={(e) => { seturlNetwork(e.label); getPostfeed(e.value, 2); setnetworkIdPurl(e.value); }} options={getNetworkdataPurl} value={getNetworkdataPurl[getNetworkdataPurl.findIndex(i => i.value == networkIdPurl)]} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <div className="input text"><label htmlFor="postpost_url">Post Url</label><input {...postUrl("post_url", { required: true, required: 'This field is required.' })} className="form-control check_reels" placeholder="Post Url" type="text" /></div>
                                                                                {errorspostUrl.post_url && <span className="text-error text-danger">{errorspostUrl.post_url.message}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label htmlFor="UrlPostFeedId">Feed</label>
                                                                                <Select key={Feedstatus} menuPlacement="auto" onChange={(e) => setfeedIdPurl(e.value)} name="CustomPostFeedId" value={feedUrl[feedUrl.findIndex(i => i.value == feedIdPurl)]} options={feedUrl} defaultValue={feedUrl[0]} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <span>Recurring Options</span>
                                                                                <span className="switch switch-xs ms-2">
                                                                                    <label className="col-form-label">
                                                                                        <input className="toggle_switcher_Post_url" onClick={(e) => setrecureEveryOptionPurl(!recureEveryOptionPurl)} defaultChecked={recureEveryOptionPurl} type="checkbox" name="select" />
                                                                                        <span></span>
                                                                                    </label>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {recureEveryOptionPurl == true ?
                                                                    <div className='modal-body pt-0'>
                                                                        <div className="separator separator-dashed mb-5"></div>
                                                                        <div className="row forRecure">
                                                                            <div className="col-sm-6">
                                                                                <div className="form-group after">
                                                                                    <div>
                                                                                        <label className="recur">
                                                                                            Recurrence
                                                                                        </label>
                                                                                        <div>
                                                                                            <Select menuPlacement="auto" onChange={(e) => setpostRecurencePurl(e.value)} options={recurrence} defaultValue={recurrence[0]} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-sm-6">
                                                                                <div className="form-group after">
                                                                                    <label className="recur">
                                                                                        Start Recurrence After
                                                                                    </label>
                                                                                    <div>
                                                                                        <Select menuPlacement="auto" onChange={(e) => setrecureAfterPurl(e.value)} options={recurrenceAfter} defaultValue={recurrenceAfter[0]} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    : null}
                                                                <div className="modal-footer">
                                                                    <div className="d-flex align-items-center justify-content-end w-100">
                                                                        <div className="card-toolbar">
                                                                            <Button variant='secondary' onClick={(e) => closecustomPost()} className="me-2" data-bs-dismiss="modal">Cancel</Button>
                                                                            <Button variant='primary' type="submit" className={`addMoreAnnocBtn ${spinnerPostUrl ? `spinner spinner-white spinner-right disabled` : null}`}>Create Custom Post</Button>

                                                                            <OverlayTrigger overlay={<Tooltip>Help</Tooltip>}>
                                                                                <a href="https://taggbox.com/support/how-to-create-add-custom-posts/" target="_blank"
                                                                                    className="commanColor absoluteRight ms-2" data-placement="right"
                                                                                    data-theme="dark" style={{ right: '15px' }}>
                                                                                    <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5 text-secondary'} />
                                                                                </a>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </Tab>}
                                                    </Tabs>
                                                </div>

                                            // ADD CUSTOM POST/URL CODE END

                                            : <div></div>}

                                    </>}

                        </>
                    </Modal.Body>
                </Modal>

                : null}

        </>
    );
};

export default CustomPost;
